module.exports = __webpack_public_path__ + "static/media/image7.374bf880.svg";